import { Logtail } from "@logtail/browser";

// Initialize Logtail with your source token
const logtail = new Logtail(`${process.env.REACT_APP_BETTER_STACK_TOKEN}`);

// Environment check
const isDev: boolean = process.env.REACT_APP_NODE_ENV === "development";

// Define metadata type for structured logging
type LogMeta = Record<string, unknown>;

interface Logger {
  log: (message: string, meta?: LogMeta) => void;
  info: (message: string, meta?: LogMeta) => void;
  error: (message: string, meta?: LogMeta) => void;
  warn: (message: string, meta?: LogMeta) => void;
  flush: () => Promise<void>;
}

const logger: Logger = {
  log: (message, meta) => {
    if (isDev) {
      console.log(`[INFO]: ${message}`, meta || "");
    } else {
      logtail.info(message, meta);
    }
  },
  info: (message, meta) => {
    if (isDev) {
      console.info(`[INFO]: ${message}`, meta || "");
    } else {
      logtail.info(message, meta);
    }
  },
  error: (message, meta) => {
    if (isDev) {
      console.error(`[ERROR]: ${message}`, meta || "");
    } else {
      logtail.error(message, meta);
    }
  },
  warn: (message, meta) => {
    if (isDev) {
      console.warn(`[WARN]: ${message}`, meta || "");
    } else {
      logtail.warn(message, meta);
    }
  },
  flush: async () => {
    if (!isDev) {
      await logtail.flush();
    }
  },
};

export default logger;
